import { Component, Input, OnInit } from '@angular/core';
import { ResumeService } from 'src/app/core/services/resume.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';

declare var saveAs: any;
declare var libphonenumber: any;

@Component({
  selector: 'app-upload-resumes-transaction-candidates-modal',
  templateUrl: './upload-resumes-transaction-candidates-modal.component.html'
})
export class UploadResumesTransactionCandidatesModalComponent implements OnInit {

  @Input() modalInstance: any;
  @Input() resolve: any;

  countsObject: any;
  countType: any;
  resumeProcessedObject: any;
  resumeProcessedActivity: any;
  modalType: any;
  activityMap: any;
  jobBoarPulledCandidatesObject: any;

  candidates: any[] = [];
  userId: any;
  candidatesQueryFilter: any;
  candidatesLoadedFlag = false;
  label = '';
  unProcessedCandidatesDownloadFileName = '';
  totalCandidatesInContainer = 3;
  callbackObject: any;

  constructor(
    private resumeService: ResumeService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.countsObject = this.resolve.countsObject;
    this.countType = this.resolve.countType;
    this.resumeProcessedObject = this.resolve.resumeProcessedObject;
    this.resumeProcessedActivity = this.resolve.activity;
    this.modalType = this.resolve.modalType;
    this.activityMap = this.resolve.activityMap;
    this.jobBoarPulledCandidatesObject = this.resolve.jobBoarPulledCandidatesObject;

    this.candidates = [];
    this.userId = this.authService.getUserDetails().id;
    this.candidatesQueryFilter = undefined;
    this.candidatesLoadedFlag = false;
    this.label = '';
    this.unProcessedCandidatesDownloadFileName = '';
    this.totalCandidatesInContainer = 3;

    this.callbackObject = { callbackType: 'cancel', entity: {} };

    if (this.countType == 'Matched') {
      this.label = 'Matched Candidates';
      this.candidates = this.countsObject.matchedCandidateIdAndNames;
    } else if (this.countType == 'UnMatched') {
      this.label = 'Unmatched Candidates';
      this.candidates = this.countsObject.unMatchedCandidateIdAndNames;
    } else if (this.countType == 'ManuallyMatched') {
      this.label = 'Manually Matched Candidates';
      this.candidates = [];
    } else if (this.countType == 'Uploaded') {
      this.label = 'Uploaded Candidates';
      this.candidates = _.uniq(_.union(this.countsObject.matchedCandidateIdAndNames, this.countsObject.unMatchedCandidateIdAndNames), 'candidateId');
    }

    if (this.modalType === 'resumeProcessed') {
      this._setResumeProcessedModal();
    }

    if (this.modalType === 'jobBoardPull') {
      this._setJobBoardPullModal();
    }

    this.candidates.forEach((val, key) => {
      val.id = val.candidateId;
      val.context = 'uploadResumesTransactionModal';
      if (key % this.totalCandidatesInContainer == 0) {
        val.uploadResumePopoverPosition = 'bottom-left';
      } else if ((key + 1) % this.totalCandidatesInContainer == 0) {
        val.uploadResumePopoverPosition = 'bottom-right';
      } else {
        val.uploadResumePopoverPosition = 'bottom';
      }
    });
    this.candidatesLoadedFlag = true;
  }

  private _setResumeProcessedModal() {
    switch (this.resumeProcessedActivity) {
      case 'Uploaded':
        this.label = 'Uploaded Candidates';
        this.candidates = _.uniq(_.union(
          this.resumeProcessedObject.update ? this.resumeProcessedObject.update.matchedCandidateIdAndNames : [],
          this.resumeProcessedObject.update ? this.resumeProcessedObject.update.unMatchedCandidateIdAndNames : [],
          this.resumeProcessedObject.create ? this.resumeProcessedObject.create.matchedCandidateIdAndNames : [],
          this.resumeProcessedObject.create ? this.resumeProcessedObject.create.unMatchedCandidateIdAndNames : []
        ), 'candidateId');
        break;
      case 'Created':
        this.label = 'Created Candidates';
        this.candidates = _.uniq(_.union(this.resumeProcessedObject.create.matchedCandidateIdAndNames, this.resumeProcessedObject.create.unMatchedCandidateIdAndNames), 'candidateId');
        break;
      case 'CreatedMatched':
        this.label = 'Created Matched Candidates';
        this.candidates = this.resumeProcessedObject.create.matchedCandidateIdAndNames;
        break;
      case 'CreatedUnMatched':
        this.label = 'Created Unmatched Candidates';
        this.candidates = this.resumeProcessedObject.create.unMatchedCandidateIdAndNames;
        break;
      case 'Updated':
        this.label = 'Updated Candidates';
        this.candidates = _.uniq(_.union(this.resumeProcessedObject.update.matchedCandidateIdAndNames, this.resumeProcessedObject.update.unMatchedCandidateIdAndNames), 'candidateId');
        break;
      case 'UpdatedMatched':
        this.label = 'Updated Matched Candidates';
        this.candidates = this.resumeProcessedObject.update.matchedCandidateIdAndNames;
        break;
      case 'UpdatedUnMatched':
        this.label = 'Updated Unmatched Candidates';
        this.candidates = this.resumeProcessedObject.update.unMatchedCandidateIdAndNames;
        break;
      case 'NotProcessed':
        this.label = 'Not Processed Candidates';
        this.candidates = _.cloneDeep(this.resumeProcessedObject.unProcessedCandidates);
        this._massageNonProcessedCandidatesData(this.candidates);
        break;
      default:
        break;
    }
  }

  private _setJobBoardPullModal() {
    switch (this.resumeProcessedActivity) {
      case 'pulled':
        this.label = 'Pulled Candidates';
        this.candidates = this.jobBoarPulledCandidatesObject.candidates;
        break;
      case 'autoMatched':
        this.label = 'Matched Candidates';
        this.candidates = this.jobBoarPulledCandidatesObject.create.matchedCandidateIdAndNames;
        break;
      case 'unMatched':
        this.label = 'Unmatched Candidates';
        this.candidates = this.jobBoarPulledCandidatesObject.create.unMatchedCandidateIdAndNames;
        break;
      case 'manuallyMatched':
        this.label = 'Manually Matched Candidates';
        this.candidates = this.jobBoarPulledCandidatesObject.create.manuallyMatchedCandidateIdAndNames;
        break;
      case 'updatedCandidates':
        this.label = 'Updated Candidates';
        this.candidates = this.jobBoarPulledCandidatesObject.create.updatedCandidateIdAndNames;
        break;
      case 'resumeNotProcessed':
        this.label = 'Resume Not Processed Candidates';
        this.candidates = this.jobBoarPulledCandidatesObject.unProcessedCandidates ? _.cloneDeep(this.jobBoarPulledCandidatesObject.unProcessedCandidates) : [];
        this._massageNonProcessedCandidatesData(this.candidates);
        break;
      default:
        break;
    }
  }

  private _massageNonProcessedCandidatesData(candidates) {
    candidates.forEach((candidate) => {
      if (candidate.firstName && candidate.lastName) {
        candidate.name = candidate.firstName + ' ' + candidate.lastName;
      } else if (!candidate.firstName && !candidate.lastName) {
        candidate.name = 'Not Available';
      } else {
        candidate.name = !candidate.firstName ? candidate.lastName : candidate.firstName;
      }

      candidate.firstName = candidate.firstName ? candidate.firstName : 'Not Available';
      candidate.lastName = candidate.lastName ? candidate.lastName : 'Not Available';
      candidate.email = candidate.email ? candidate.email : 'Not Available';
      candidate.phone = candidate.phone ? candidate.phone : 'Not Available';

      if (candidate.mobilePhoneCountryCodePresent) {
        let phoneNumberObject = libphonenumber.parse(candidate.phone.toString());
        if (phoneNumberObject.phone !== undefined) {
          candidate.phone = libphonenumber.format(phoneNumberObject.phone, phoneNumberObject.country, 'International');
        }
      }
      candidate.score = Math.floor(parseFloat(candidate.score));
    });
  }

  downloadAllResumes() {
    let unprocessedCandidateList = [];
    this.resumeProcessedObject.unProcessedCandidates.forEach(candidate => {
      unprocessedCandidateList.push({ resumeId: candidate.resumeId, failureReason: candidate.failureReason });
    });

    let unprocessedCandidateObj = {
      candidateUnProcessedResumeList: unprocessedCandidateList
    };

    this.resumeService.downloadAllResumes(unprocessedCandidateObj, (data) => {
      if (data.status == 200) {
        let fileName = '';
        fileName = data.headers.get('content-disposition').split(';')[1].split('=')[1].slice(1).slice(0, -1);
        this.unProcessedCandidatesDownloadFileName = fileName ? fileName : 'resumesnotprocessed.zip';
        saveAs(data.body, this.unProcessedCandidatesDownloadFileName);
      } else {
        this.alertsAndNotificationsService.showBannerMessage('Download Zip file failed', 'danger');
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.error, 'danger');
    });
  }

  saveCallback(contactDetails) {
    this.callbackObject.callbackType = 'save';
    this.callbackObject.entity = contactDetails;
    this.closeModal();
  }

  closeModal() {
    this.modalInstance.close(this.callbackObject);
  }

  dismissModal() {
    this.modalInstance.dismiss('cancel');
  }
}
